import { render, staticRenderFns } from "./FantasyCardPlayerSlide.vue?vue&type=template&id=1e8716a7&"
import script from "./FantasyCardPlayerSlide.vue?vue&type=script&lang=js&"
export * from "./FantasyCardPlayerSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports